import Vue from 'vue'
import Router from 'vue-router'
import ViewFreight from '@/components/ViewFreight'
import NewFreight from '@/components/NewFreight'
import FreightDetail from '@/components/FreightDetail'
import BrokerFreightDetail from '@/components/BrokerFreightDetail'
import BrokerDetail from '@/components/BrokerDetail'
import Brokers from '@/components/Brokers'
import Shippers from '@/components/Shippers'
import Login from '@/components/Login'
import SignUP from '@/components/SignUp'
import Hello from '@/components/Hello'
import ViewImages from '@/components/ViewImages'
import Error404 from '../components/Error404.vue'
import News from '../components/News.vue'
import Firebase from 'firebase'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'hello',
    component: Hello
  },
  {
    path: '/viewfreight',
    name: 'viewfreight',
    component: ViewFreight,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/freight',
    name: 'newfreight',
    component: NewFreight,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/brokerfreight',
    name: 'brokerfreight',
    props: true,
    component: BrokerFreightDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/broker',
    name: 'brokerdetail',
    component: BrokerDetail,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/shipperfreight',
    name: 'shipperfreight',
    props: true,
    component: FreightDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/viewimages',
    name: 'viewimages',
    props: true,
    component: ViewImages,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/brokers',
    name: 'brokers',
    component: Brokers,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/shippers',
    name: 'shippers',
    component: Shippers,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/news',
    name: 'news',
    component: News
  },
  {
    path: '/signup',
    name: 'signup',
    component: SignUP
  },
  {
    path: '/404',
    name: '404',
    component: Error404
  },
  {
    path: '/index.html',
    name: 'index',
    component: Hello
  },
  {
    path: '*',
    redirect: '/404'
  }
  ]
})

router.beforeEach((to, from, next) => {
  const currentUser = Firebase.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !currentUser) {
    next('/')
  } else if (requiresAuth && currentUser) {
    next()
  } else {
    next()
  }
})

const messaging = Firebase.messaging()
messaging.onTokenRefresh(function () {
  messaging.getToken().then(function (refreshedToken) {
    console.log('Token refreshed.')
    // Indicate that the new Instance ID token has not yet been sent to the
    // app server.
    // setTokenSentToServer(false)
    // Send Instance ID token to app server.
    // sendTokenToServer(refreshedToken)
    // ...
  }).catch(function (err) {
    console.log('Unable to retrieve refreshed token ', err)
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js